import { render } from "./categories_multi.vue?vue&type=template&id=72e9f88a"
import script from "./categories_multi.vue?vue&type=script&lang=js"
export * from "./categories_multi.vue?vue&type=script&lang=js"

import "./categories_multi.vue?vue&type=style&index=0&id=72e9f88a&lang=css"

import exportComponent from "D:\\vue\\alive-again\\sams-alive-again\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__